module.exports = __webpack_public_path__ + "static/media/foto_met_zn_allen.450ca156.jpg";